import { FC } from 'react';

import { IconProps } from './types';

export const TemperatureSnowlakeIcon: FC<IconProps> = ({
	size,
	width = 24,
	height = 24,
	color = '#0A2653',
}) => (
	<svg
		width={size ?? width}
		height={size ?? height}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.5 22.334C16.27 22.779 17.125 23.006 17.992 23.006C18.426 23.006 18.863 22.949 19.294 22.834C20.584 22.488 21.662 21.66 22.33 20.504C23.607 18.291 22.996 15.498 21 14.004V4C21 2.346 19.654 1 18 1C16.346 1 15 2.346 15 4V14.004C14.462 14.407 14.009 14.918 13.67 15.504C12.292 17.892 13.112 20.955 15.5 22.334ZM17 4C17 3.449 17.448 3 18 3C18.552 3 19 3.449 19 4V14.542C19 14.899 19.19 15.229 19.5 15.408C20.194 15.808 20.69 16.455 20.897 17.229C21.104 18.003 20.997 18.811 20.597 19.505C20.197 20.199 19.549 20.695 18.776 20.903C18.002 21.107 17.193 21.004 16.5 20.602C15.067 19.775 14.575 17.937 15.402 16.504C15.665 16.048 16.045 15.668 16.499 15.406C16.81 15.228 17 14.897 17 14.54V4Z"
			fill={color}
		/>
		<path
			d="M8 20C8 20.553 8.448 21 9 21C9.552 21 10 20.553 10 20V17.3663C10.3825 17.5877 10.8794 17.5347 11.207 17.207C11.598 16.816 11.598 16.184 11.207 15.793L10 14.586V13H12C12.552 13 13 12.552 13 12C13 11.448 12.552 11 12 11H10V9.41401L12.707 6.70701C13.098 6.31601 13.098 5.68401 12.707 5.29301C12.316 4.90201 11.684 4.90201 11.293 5.29301L10 6.58601V4C10 3.448 9.552 3 9 3C8.448 3 8 3.448 8 4V6.586L6.70701 5.29301C6.31601 4.90201 5.68401 4.90201 5.29301 5.29301C4.90201 5.68401 4.90201 6.31601 5.29301 6.70701L8 9.414V11H6.414L3.70701 8.29301C3.31601 7.90201 2.68401 7.90201 2.29301 8.29301C1.90201 8.68401 1.90201 9.31601 2.29301 9.70701L3.586 11H2C1.448 11 1 11.448 1 12C1 12.552 1.448 13 2 13H3.58601L2.29301 14.293C1.90201 14.684 1.90201 15.316 2.29301 15.707C2.48801 15.902 2.74401 16 3.00001 16C3.25601 16 3.51201 15.902 3.70701 15.707L6.41401 13H8V14.586L5.29301 17.293C4.90201 17.684 4.90201 18.316 5.29301 18.707C5.48801 18.902 5.74401 19 6.00001 19C6.25601 19 6.51201 18.902 6.70701 18.707L8 17.414V20Z"
			fill={color}
		/>
	</svg>
);
